import { render, staticRenderFns } from "./TraspasosView.vue?vue&type=template&id=b095186c&"
import script from "./TraspasosView.vue?vue&type=script&lang=js&"
export * from "./TraspasosView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports